import { defineStore } from "pinia";
import { Device } from "@capacitor/device";
// import { Network } from "@capacitor/network";

import SessionResource from "~/models/scanning/Session";
import StationResource from "~/models/scanning/Station";

export const useScanningStore = defineStore("scanning", {
  state: () => ({
    ready: false,
    // menu: [],
    school_year: [],
    buildings: [],
    default_locations: [],
    period_options: [],
    calendar: [],
    parsers: [],
    bell_schedules: [],
    attendance_today: [],
    min_app_version: null,

    loading_sessions: false,
    sessions: [],

    loading_stations: false,
    stations: [],

    station: {
      id: null,
      name: null,

      hardware_uuid: null,

      hardware_name: null,
      operating_system: null,
      os_version: null,
      platform_name: null,
      platform_version: null,
      user_agent: null,
      manufacturer: null,
      model: null,
      is_virtual: null,

      language_code: null,

      battery_level: null,
      is_charging: null,

      is_connected: null,
      connection_type: null,
    },

    network_ready: false,
    network_status: {
      connected: false,
      connectionType: "unknown",
    },
  }),
  getters: {},
  actions: {
    async loadConfig() {
      this.ready = null;
      try {
        const response = await StationResource.custom("meta").first();

        this.school_year = response.school_year;
        this.buildings = response.buildings;
        this.parsers = response.parsers;
        this.default_locations = response.default_locations;
        this.period_options = response.period_options;
        this.calendar = response.calendar;
        this.bell_schedules = response.bell_schedules;
        this.min_app_version = response.min_app_version;

        this.loadStations();

        this.ready = true;
      } catch (error) {
        this.ready = false;
        if (!error.response) {
          console.log(error);
        } else {
          useApiResponseHandler().error(error, 'Unable to retrieve scanning system configuration');
        }
      }
    },
    async loadSessions() {
      this.loading_sessions = true;
      try {
        const response = await SessionResource
          .orderBy("location")
          .all();
        this.sessions = response.data.map(s => new SessionResource(s));
      } catch (error) {
        if (!error.response) {
          console.log(error);
        } else {
          useApiResponseHandler().error(error, 'Error loading sessions');
        }
      }
      this.loading_sessions = false;
    },
    async loadStations() {
      this.loading_stations = true;
      try {
        const response = await StationResource
          .orderBy("name")
          .all();
        this.stations = response.data.map(s => new StationResource(s));
      } catch (error) {
        if (!error.response) {
          console.log(error);
        } else {
          useApiResponseHandler().error(error, 'Error loading stations');
        }
      }
      this.loading_stations = false;
    },
    async loadStationInfo() {
      const info = await Device.getId();
      try {
        this.station = await StationResource.$find(info.identifier);
      } catch (error) {
        if (!error.response) {
          console.log(error);
        } else {
          if (error.response.status !== 404) {
            useApiResponseHandler().error(error, 'Unable to retrieve scanning station configuration');
          }
        }
      }
    },
  },
});
